__turbopack_context__.v({
  "darktext": "SplitViewHtml-module-scss-module__Gdjb0G__darktext",
  "rowSwapped": "SplitViewHtml-module-scss-module__Gdjb0G__rowSwapped",
  "splitview": "SplitViewHtml-module-scss-module__Gdjb0G__splitview",
  "splitviewcode": "SplitViewHtml-module-scss-module__Gdjb0G__splitviewcode",
  "splitviewtext": "SplitViewHtml-module-scss-module__Gdjb0G__splitviewtext",
  "swapped": "SplitViewHtml-module-scss-module__Gdjb0G__swapped",
});
